export default "__VITE_ASSET__hRvwp0H$__"